import CopyOutlined from "@ant-design/icons/CopyOutlined";
import EditOutlined from "@ant-design/icons/EditOutlined";
import React, { useState } from "react";
import { copyCodeOrLinkToClipboard } from "features/affiliation/common/utils";
import EditLinkModal from "features/affiliation/ReferralLinks/EditLinkModal";
import { ReferralLink } from "types/affiliation.types";
import { TableActionsEllipsisOutlined } from "features/affiliation/common/styles";
import Dropdown from "common/Dropdown/Dropdown";
import LookIcon from "common/Icons/LookIcon";
import { Copy, Pencil } from "lucide-react";
import { useTheme } from "styled-components";
import { MenuTrigger } from "features/affiliation/NewLook/parts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface ReferralLinkActionsProps {
  referralLinkData: ReferralLink;
  /** New look: a 40px trigger for phone rows. */
  largeTrigger?: boolean;
}

const ReferralLinkActions = ({
  referralLinkData,
  largeTrigger,
}: ReferralLinkActionsProps) => {
  const { isNewLook } = useTheme();
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const openEditLinkModal = () => {
    setIsEditModalVisible(true);
  };
  const closeEditLinkModal = () => {
    setIsEditModalVisible(false);
  };

  const menuItems = [
    {
      key: "editReferralLink",
      icon: (
        <LookIcon
          classic={<EditOutlined />}
          newLook={<Pencil size={16} strokeWidth={1.75} />}
        />
      ),
      label: t("common.edit"),
      onClick: openEditLinkModal,
    },
    {
      key: "copyReferralLink",
      icon: (
        <LookIcon
          classic={<CopyOutlined />}
          newLook={<Copy size={16} strokeWidth={1.75} />}
        />
      ),
      label: t("common.copy"),
      onClick: () =>
        copyCodeOrLinkToClipboard(referralLinkData.referral_code, true),
    },
  ];

  return (
    <>
      <Dropdown
        title={t("common.actions")}
        menu={{ items: menuItems }}
        placement="bottomRight"
        trigger={["click"]}
      >
        {isNewLook ? (
          <MenuTrigger $large={largeTrigger} />
        ) : (
          <TableActionsEllipsisOutlined />
        )}
      </Dropdown>
      <EditLinkModal
        isVisible={isEditModalVisible}
        closeModal={closeEditLinkModal}
        referralLink={referralLinkData}
      />
    </>
  );
};

export default ReferralLinkActions;
